module.exports = require('./lib/with-html')



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-markdown/with-html.js
// module id = 430
// module chunks = 0